import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { Reminder } from '@aid/reminders/types/classes';
import { OrganizationMember } from '@aid/core/types/classes/organization-member.class';
import { Member } from '@aid/members/types/classes';

@Component({
  selector: 'aid-reminder-item-option',
  template: `
    <div
      class="container aid-layout-row aid-layout-align-space-between-center aid-layout-gap-8"
      (click)="onSelect()"
    >
      <div class="aid-layout-column">
        <div class="mat-subtitle-2 text">
          {{ reminder.text }}
        </div>
        @if (isAssigned()) {
          <div class="assigned">
            {{ 'assigned-by' | translate | sentancecase }}
            {{ ownerName }}
          </div>
        }
      </div>
      <div class="aid-layout-column">
        <div class="due-date">{{ reminder.dueDate | date: 'shortDate' }}</div>
        <div class="due-time">{{ reminder.dueDate | date: 'shortTime' }}</div>
      </div>
    </div>
    @if (!last) {
      <mat-divider></mat-divider>
    }
  `,
  styleUrls: ['./reminder-item-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ReminderItemOptionComponent implements OnInit {
  @Input({ required: true }) reminder = new Reminder();
  @Input() currentMember: OrganizationMember | null = null;
  @Input() last = false;
  @Output() select = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {}

  onSelect() {
    this.select.emit();
  }

  isAssigned() {
    if (!this.currentMember) {
      throw new Error('Reminder assignment needs the current member.');
    }
    return this.currentMember.member !== (this.reminder.owner as Member).id;
  }

  get ownerName(): string | undefined {
    return (this.reminder.owner as Member).name;
  }
}
